import Checkbox from './components/basic/CheckBox';
import Input from './components/basic/Input';
import TextArea from './components/basic/TextArea';
import TwoLanguageInput from './components/twoLanguage/TwoLanguageInput';
import WorkFlowState from './components/workflow/WorkFlowState';
import DateInput from './components/basic/DateInput';
import PriceInput from './components/basic/PriceInput';
import Derivate from './components/derivate/Derivate';
import {OnClickInput} from './components/modalDropdown/OnClickInput';
import TextInput from './components/basic/TextInput';
import NumberInput from './components/basic/NumberInput';
import TwoLanguageTextArea from './components/twoLanguage/TwoLanguageTextArea';
import {TwoLanguageCompareTextArea} from './components/twoLanguage/TwoLanguageCompareTextArea';
import {TwoLanguageCompareInput} from './components/twoLanguage/TwoLanguageCompareInput';
import ColorDropdown from "./components/dropdowns/ColorDropdown";
import PortalDropdown from "./components/dropdowns/PortalDropdown";
import {EVirtualizedTableCellType} from "./VirtualizedTableEnums";
import ReferenceCell from "./components/basic/ReferenceCell";
import TextFlagCell from "./components/basic/TextFlagCell";
import OptionIndicatorCell from "./components/basic/optionIndicator/OptionIndicatorCell";
import GenerationCell from './components/basic/GenerationCell';

/**
 * build a component based on the enum EDynTableType
 */
export const buildComponent = (type: EVirtualizedTableCellType) => {
    switch (type) {
        case EVirtualizedTableCellType.TEXTINPUT:
            return TextInput;
        case EVirtualizedTableCellType.NUMBERINPUT:
            return NumberInput;
        case EVirtualizedTableCellType.CHECKBOX:
            return Checkbox;
        case EVirtualizedTableCellType.WORKFLOWSTATE:
            return WorkFlowState;
        case EVirtualizedTableCellType.TEXTAREA:
            return TextArea;
        case EVirtualizedTableCellType.DROPDOWN:
            return PortalDropdown;
        case EVirtualizedTableCellType.TWOLANGUAGEINPUT:
            return TwoLanguageInput;
        case EVirtualizedTableCellType.TWOLANGUAGETEXTAREA:
            return TwoLanguageTextArea;
        case EVirtualizedTableCellType.TWOLANGUAGECOMPAREINPUT:
            return TwoLanguageCompareInput;
        case EVirtualizedTableCellType.TWOLANGUAGECOMPARETEXTAREA:
            return TwoLanguageCompareTextArea;
        case EVirtualizedTableCellType.DATE:
            return DateInput;
        case EVirtualizedTableCellType.PRICE:
            return PriceInput;
        case EVirtualizedTableCellType.DERIVATE:
            return Derivate;
        case EVirtualizedTableCellType.ONCLICKINPUT:
            return OnClickInput;
        case EVirtualizedTableCellType.DEFAULTINPUT:
            return Input;
        case EVirtualizedTableCellType.COLORDROPDOWN:
            return ColorDropdown;
        case EVirtualizedTableCellType.REFERENCE:
            return ReferenceCell;
        case EVirtualizedTableCellType.OPTION_INDICATOR:
            return OptionIndicatorCell;
        case EVirtualizedTableCellType.FLAG:
            return TextFlagCell;
        case EVirtualizedTableCellType.GENERATION:
            return GenerationCell;
        default:
            return Input;
    }
};



// WEBPACK FOOTER //
// ./src/components/Table/ComponentBuilder.tsx